import React, { useState ,  useContext } from 'react'
import bgImg from '../../../Image/dreamstars_bg.png';
import logoImg from '../../../Image/dreamstars_logo.png'
import { Link, useNavigate } from "react-router-dom";
import userimg from '../../../Image/ruser.png';
import { APIRequest, ApiUrl } from '../../../Helpers/ApiHelper';
import { Notification, Placeholder, useToaster } from 'rsuite';
import ErrorHelper from '../../../Helpers/ErrorHelper'
import CustomLoader from '../../comman/Loader/CustomLoader';
import { Auth } from '../../../Contexts/AuthContext';
import arrowImg from '../../../favicon/arrow_left.png'
import backButton from '../../../Image/backButton.svg'
import Footer from '../../comman/Footer';


const ForgotInfulencerHome = () => {
  const navigate = useNavigate();

  const { formData, setFormData } = useContext(Auth);
  const [isLoading, setIsLoading] = useState(false);
  const toaster = useToaster();
  const [validataionErrors, setValidataionErrors] = useState([])
  const changeInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    const collect = {
      ...formData,
      [name]: value
    };

    const IsError = validataionErrors?.find(v => v.field == name);
        console.log("is : ", IsError);
        if (IsError !== undefined) {
            const errors = validataionErrors?.filter(v => v.field !== name);
            setValidataionErrors(errors);
        }
        

    setFormData(collect);
  }

  const handleSubmit = (e) => {
    setIsLoading(true);
    e.preventDefault();
    let config = {
      url: ApiUrl.forgotPasswordInfulencer,
      method: 'post',
      body: {
        email: formData?.email,
        device_token: '',
      },
    };

    APIRequest(
      config,

      res => {
        setIsLoading(false);
        if (res?.success) {
          navigate("/infulencer/reset-password")
        }
        toaster.push(<Notification type="success" header="Success" >
          <Placeholder.Paragraph type="success" header="Success" style={{ width: 100, color: 'red' }} rows={0} /> Sent you an OTP for resetting password</Notification>
          , {
            placement: 'topEnd'
          });


      },
      err => {
        setIsLoading(false);
        if (err.response.status == 422) {
          setValidataionErrors(err?.response?.data?.errors);

        } else {
          toaster.push(<Notification type="error" header="Error" >
            <Placeholder.Paragraph type="error" header="Error" style={{ width: 100, color: 'red' }} rows={0} /> {err?.message}</Notification>
            , {
              placement: 'topEnd'
            });

        }
      },
    );



  }



  return (
    <>
      <CustomLoader visible={isLoading} />
      <div className="mainBg w-screen min-h-screen bg-cover bg-center bg-no-repeat
      justify-center items-center flex " >
       
      <img onClick={()=>{navigate("/")}}  src={backButton} alt="backButton_img" className="cursor-pointer absolute top-5 left-8" />

        <form onSubmit={handleSubmit} className='flex flex-col login-form font-museob w-[300px] sm:w-[440px] lg:w-[480px]'  >
          <div className='h-[47px]  flex items-center  rounded-full'  style={{ boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px', width: "100%", borderRadius: "8px" }} >
            <div className='rounded-l-lg   bg-white h-full w-[18%] flex justify-center items-center'><img src={userimg} className="w-5" alt="user_img" ></img></div>
            <input onChange={changeInput} className=" w-full h-full   border-none outline-none rounded-r-lg placeholder:pr-[18%]  placeholder:text-center placeholder:text-slate-300" value={formData?.email}  type="email" name="email" id="email" placeholder="Email Address" required  ></input>
          </div>
          {ErrorHelper(validataionErrors, "email")}

            <div className='w-full flex justify-center  items-center mt-3' > 
              <button style={{ boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px' }}
               type="submit" id='submit' className=' btn-anim i bg-[#00B048] w-[200px] lg:w-[268px] h-[47px] rounded-lg   text-white font-museobb '>CONTINUE</button>
          </div>

        </form>


        <div className='absolute bottom-0' ><Footer colorClass="footerColor2" clas="footer"  /></div>



      </div>
    </>

  )
}

export default ForgotInfulencerHome
